import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import deepmerge from 'deepmerge'
import zhcode from "./zh_code";
let lang = {
  ...zhcode,
  设备列表: "设备列表",
  收款明细: "收款明细",
  使用明细: "使用明细",
  智电生态: "智电生态",
  导出记录: "导出记录",
  APP下载: "APP下载",
  下载手机APP: "下载手机APP",
  手机管理更方便: "手机管理更方便",
  消息记录: "消息记录",
  价格管理: "价格管理",
  退出登录: "退出登录",
  请输入设备名称: "请输入设备名称",
  操作时间: "操作时间",
  至: "至",
  导出: "导出",
  查询: "查询",
  序号: "序号",
  用电量kwh: "用电量(kW·h)",
  本年收款: "本年收款",
  本月收款: "本月收款",
  交易时间: "交易时间",
  层级列表: "层级列表",
  欢迎登入智电生态: "欢迎登入智电生态",
  您输入的手机号或密码有误请重新输入: "您输入的手机号或密码有误，请重新输入",
  请输入手机号: "请输入手机号",
  请输入密码: "请输入密码",
  记住密码: "记住密码",
  登录: "登录",
  登录成功: "登录成功",
  长度在6到20个字符: "长度在 6 到 20 个字符",
  只支持房东登录: "只支持房东登录",
  搜索: "搜索",
  中国大陆: "中国大陆",
  温馨提示: "温馨提示",
  第一次登录用户为了您的帐户安全请先重置您的登录密码: "第一次登录用户，为了您的帐户安全，请先重置您的登录密码",
  前往重置: "前往重置",
  设置新的登录密码: "设置新的登录密码",
  首次登录用户为了您帐户的安全请先重设您的登录密码: "首次登录用户，为了您帐户的安全，请先重设您的登录密码",
  请输入新密码: "请输入新密码",
  请再次输入新密码: "请再次输入新密码",
  密码长度必须限制为620个字符并且使用至少1个字母和1个数字: "密码长度必须限制为6~20个字符，并且使用至少1个字母和1个数字",
  密码长度不能小于6位: "密码长度不能小于6位",
  密码长度不能大于20位: "密码长度不能大于20位",
  密码至少包含1个字母和1个数字: "密码至少包含1个字母和1个数字",
  输入密码不一致: "输入密码不一致",
  导出信息: "导出信息",
  当前无导出数据: "当前无导出数据",
  导出记录只保存7天: "导出记录只保存 7 天",
  导出成功: "导出成功",
  导出中: "导出中",
  总数: "总数",
  刷新: "刷新",
  文件名称: "文件名称",
  创建时间: "创建时间",
  任务状态: "任务状态",
  完成时间: "完成时间",
  状态信息: "状态信息",
  下载: "下载",
  删除: "删除",
  删除成功: "删除成功",
  您是否确认要删除: "您是否确认要删除？",
  提示: "提示",
  确定: "确定",
  确认: "确认",
  取消: "取消",
  全部: "全部",
  个人中心: "个人中心",
  电价管理: "电价管理",
  元: "元",
  您是否确认要删除该价格: "您是否确认要删除该价格?",
  删除电价: "删除电价",
  添加电价: "添加电价",
  修改电价: "修改电价",
  电价名称: "电价名称",
  请输入电价名称: "请输入电价名称",
  请输入电价金额: "请输入电价金额",
  单价: "单价",
  请输入单价: "请输入单价",
  备注: "备注",
  请输入备注: "请输入备注",
  添加成功: "添加成功",
  修改成功: "修改成功",
  账号信息: "账号信息",
  用户名称: "用户名称",
  修改: "修改",
  修改密码: "修改密码",
  已设置登录密码: "已设置登录密码",
  修改用户名称: "修改用户名称",
  名称: "名称",
  请输入名称: "请输入名称",
  旧密码: "旧密码",
  请输入旧密码: "请输入旧密码",
  新密码: "新密码",
  确认密码: "确认密码",
  密码输入不符合规则: "密码输入不符合规则",
  两次密码输入不一致: "两次密码输入不一致",
  添加层级: "添加层级",
  暂无数据: "暂无数据",
  您是否确认删除该层级: "您是否确认删除该层级",
  修改层级: "修改层级",
  层级名称: "层级名称",
  请输入层级名称: "请输入层级名称",
  详细地址: "详细地址",
  请输入详细地址街道楼牌号等: "请输入详细地址街道楼牌号等",
  请输入: "请输入",
  设备名称: "设备名称",
  表号: "表号",
  租客姓名: "租客姓名",
  剩余电量kWh: "剩余电量(kW·h)",
  剩余电量2: "剩余电量",
  剩余电量3: "剩余电量",
  状态: "状态",
  刷新时间: "刷新时间",
  操作: "操作",
  排序: "排序",
  设备通电: "设备通电",
  设备断电: "设备断电",
  设备离线: "设备离线",
  默认排序: "默认排序",
  由大到小: "由大到小",
  由小到大: "由小到大",
  添加设备: "添加设备",
  电价调整: "电价调整",
  查看详情: "查看详情",
  更换租客: "更换租客",
  代客充值: "代客充值",
  资产号: "资产号",
  请输入资产号: "请输入资产号",
  电价方案: "电价方案",
  请选择电价方案: "请选择电价方案",
  安装地址: "安装地址",
  请输入安装地址: "请输入安装地址",
  请输入租客姓名: "请输入租客姓名",
  联系电话: "联系电话",
  请输入联系电话: "请输入联系电话",
  保存: "保存",
  电价: "电价",
  请选择: "请选择",
  元kWh: "元/kW·h",
  请选择电价: "请选择电价",
  请选择设备: "请选择设备",
  所选设备价格与修改价格一致无需修改: "所选设备价格与修改价格一致,无需修改",
  美国: "美国",
  更换租客成功: "更换租客成功",
  通电: "通电",
  断电: "断电",
  离线: "离线",
  租客名称: "租客名称",
  剩余电量: "剩余电量",
  剩余水电量: "剩余水电量",
  充值电量: "充值电量",
  请输入充值电量: "请输入充值电量",
  充值金额: "充值金额",
  确认充值: "确认充值",
  充值成功回执单: "充值成功回执单",
  充值回执单: "充值回执单",
  订单编号: "订单编号",
  客户名称: "客户名称",
  充值Token: "充值Token",
  支付时间: "支付时间",
  我知道了: "我知道了",
  充值成功: "充值成功",
  复制成功: "复制成功",
  删除设备: "删除设备",
  设备信息: "设备信息",
  费用明细: "费用明细",
  操作记录: "操作记录",
  充值记录: "充值记录",
  数据统计仅保留近一年内的记录: "数据统计仅保留近一年内的记录",
  业主: "业主",
  操作人: "操作人",
  时间: "时间",
  项目: "项目",
  充值电量kwh: "充值电量(kW·h)",
  充值金额3: "充值金额",
  充值电量3: "充值电量(kW·h)",
  设备类型: "设备类型",
  总用电量: "总用电量",
  电流: "电流",
  电压: "电压",
  wifi账号: "wifi账号",
  wifi密码: "wifi密码",
  设备: "设备",
  成功: "成功",
  成功1: "成功",
  清零: "清零",
  清窃电: "清窃电",
  您是否确认通电: "您是否确认通电",
  您是否确认断电: "您是否确认断电",
  您是否要清窃电: "您是否要清窃电",
  您是否要清电量: "您是否要清电量",
  修改价格: "修改价格",
  您的设备为键盘表需要手动输入Token进行: "您的设备为键盘表,需要手动输入Token进行",
  本次: "本次",
  为: "为",
  电表: "电表",
  水表: "水表",
  修改名称: "修改名称",
  请选择价格: "请选择价格",
  电表刷新: "电表刷新",
  拉合闸状态: "拉合闸状态",
  功率因数: "功率因数",
  刷新成功: "刷新成功",
  当前价格: "当前价格",
  设备消息: "设备消息",
  告警消息: "告警消息",
  账号消息: "账号消息",
  公告消息: "公告消息",
  暂无消息: "暂无消息",
  您是否确认删除该设备: "您是否确认删除该设备?",
  请输入最多两位小数的有效数字: "请输入最多两位小数的有效数字",
  加载中: "加载中...",
  刷新失败: "刷新失败",
  您还未设置电价: "您还未设置电价",
  去设置: "去设置",
  您还未创建分组请先添加分组: "您还未创建分组请先添加分组",
  币种设置: "币种设置",
  设置货币: "设置货币",
  国家币种: "国家名称/币种名称",
  请输入国家名称或币种名称: "请输入国家名称或币种名称",
  智电官网: "智电官网",
  电话: "电话",
  邮箱: "邮箱",
  当前选择已设置: "当前选择已设置",
  不能有特殊字符: "不能有特殊字符",
  阈值设置: "阈值设置",
  功率门限阈值: "功率门限阈值",
  请输入功率门限阈值: "请输入功率门限阈值",
  读取: "读取",
  设置: "设置",
  请输入数字: "请输入数字",
  历史数据: "历史数据",
  日: "日",
  月: "月",
  年: "年",
  序号2: "序号",
  分组名称: "分组名称",
  总电量: "总电量",
  总水量: "总水量",
  A相电压: "A相电压",
  B相电压: "B相电压",
  C相电压: "C相电压",
  A相电流: "A相电流",
  B相电流: "B相电流",
  C相电流: "C相电流",
  功率因素: "功率因素",
  选择日期: "选择日期",
  阈值范围: "阈值范围10-1000000w",
  读取成功: "读取成功",
  设置成功: "设置成功",
  水价方案: "水价方案",
  请选择水价方案: "请选择水价方案",
  添加水价方案: "+添加水价方案",
  价格调整: "价格调整",
  水价: "水价",
  热水价: "热水价",
  批量修改电价: "批量修改电价",
  批量修改水价: "批量修改水价",
  水价管理: "水价管理",
  添加水价: "添加水价",
  修改水价: "修改水价",
  水价名称: "水价名称",
  请输入水价名称: "请输入水价名称",
  请输入水价金额: "请输入水价金额",
  水价类型: "水价类型",
  删除水价: "删除水价",
  剩余水量: "剩余水量",
  剩余水量2: "剩余水量",
  剩余额度: "剩余额度",
  水表清零: "水表清零",
  充值水量: "充值水量",
  充值方式: "充值方式",
  电量: "电量",
  金额: "金额",
  水量: "水量",
  请输入充值水量: "请输入充值水量",
  开阀: "开阀",
  关阀: "关阀",
  总用水量: "总用水量",
  当月用水量: "当月用水量",
  水表操作提醒: "当前暂无操作命令",
  您是否要清水量: "您是否要清水量",
  您是否确认开阀: "您是否确认开阀",
  您是否确认关阀: "您是否确认关阀",
  昨日用水量: "昨日用水量",
  用水量m: "用水量(m³)",
  充值水量1: "充值水量(m³)",
  设备通电开阀: "设备通电/开阀",
  设备断电关阀: "设备断电/关阀",
  阀控故障: "阀控故障",
  继电器故障: "继电器故障",
  支付方式: "支付方式",
  支付宝: "支付宝",
  银行卡: "银行卡",
  微信: "微信",
  支付宝小程序: "支付宝小程序",
  微信小程序: "微信小程序",
  Paystack: "Paystack",
  线下支付: "线下支付",
  操作成功: "操作成功",
  二级密码: "二级密码",
  验证二级密码: "验证二级密码",
  请输入二级密码: "请输入二级密码",
  请再次输入二级密码: "请再次输入二级密码",
  已设置二级密码: "已设置二级密码",
  删除密码: "删除密码",
  您正在操作删除二级密码请完成校验: "您正在操作删除二级密码，请完成校验",
  未设置: "未设置",
  付费模式: "付费模式",
  预付费: "预付费",
  后付费: "后付费",
  远程抄表: "远程抄表",
  账单列表: "账单列表",
  账单年月: "账单年月",
  账单状态: "账单状态",
  批量收款: "批量收款",
  总用金额: "总用金额",
  收款日期: "收款日期",
  确认收款: "确认收款",
  收款时间: "收款时间",
  未收款: "未收款",
  已收款: "已收款",
  逾期: "逾期",
  异常: "异常",
  未知: "未知",
  前往: "前往",
  原模式: "原模式",
  待执行: "待执行",
  目标模式: "目标模式",
  失败原因: "失败原因",
  失败重试: "失败重试",
  总用水电量: "总用水电量",
  请勾选要批量收款的账单: "请勾选要批量收款的账单",
  请输入账号: "请输入账号",
  您输入的账号或密码有误请重新输入: "您输入的账号或密码有误，请重新输入",
  失败: "失败",
  付费模式设置: "付费模式设置",
  预付费模式: "预付费模式",
  先充值再用电欠费自动断电: "先充值，再用电，欠费自动断电。",
  当前模式: "当前模式",
  切换至此: "切换至此",
  后付费模式: "后付费模式",
  先用电后付费账单月结逾期自动断电: "先用电，后付费，账单月结，逾期自动断电。",
  远程抄表模式: "远程抄表模式",
  远程自动采集记录用户用电等数据无计费功能: "远程自动采集记录用户用电等数据，无计费功能。",
  切换设备列表: "切换设备列表",
  切换状态: "切换状态",
  没有可重试的设备: "没有可重试的设备",
  您确定要对切换失败的设备进行重试吗: "您确定要对切换失败的设备进行重试吗？",
  正在重试: "正在重试",
  缴费截止日期: "缴费截止日期",
  请填写缴费截止日期: "请填写缴费截止日期",
  时: "时",
  逾期断电: "逾期断电",
  开启: "开启",
  关闭: "关闭",
  您即将切换付费模式此操作会导致剩余电量清零: "您即将切换付费模式，此操作会导致剩余电量清零。",
  您即将切换付费模式切换后系统将实时扣费请确保账户余额充足: "您即将切换付费模式，切换后系统将实时扣费，请确保账户余额充足。",
  您确定要将付费模式切换为: "您确定要将付费模式切换为",
  日期输入范围为: "日期输入范围为",
  小时输入范围为: "小时输入范围为",
  您有设备未完成付费模式切换请及时处理: "您有设备未完成付费模式切换，请及时处理。",
  开始时间: "开始时间",
  结束时间: "结束时间",
  开始示数: "开始示数",
  结束示数: "结束示数",
  安卓版下载: "安卓版下载",
  扫描下载安卓版: "扫描下载安卓版",
  iOS版下载: "iOS版下载",
  扫描下载iOS版: "扫描下载iOS版",
  联系方式: "联系方式",
  智慧用电: "智慧用电",
  更新公告: "系统充值界面升级通知",
  更新内容信息1: "亲爱的用户, 您好！：",
  更新内容信息: "为优化服务体验、提升系统运行效率，我司将于2026 年 1 月 19 日正式上线充值系统全新界面。本次升级完成后，原系统中的所有数据将全部迁移至新系统，确保数据完整无误。" +
    "本次升级不影响原有功能的使用，您的账号信息保持不变。登录新系统时，无需手动选择区号，直接输入原账号格式（hk + 账号主体，示例：hkxxxxxx）及原密码，即可正常登录使用。" +
    "若您在登录或使用过程中遇到任何问题，可随时通过页面【Contact us】的联系方式与我们取得联系，我们将竭诚为您提供技术支持与解决方案。",
  更新内容信息2: "感谢您的理解与支持!",
  不再提醒: "不再提醒",
  打印: "打印",
  查看回执单: "查看回执单",
}
let zh = deepmerge({ lang }, zhLocale, { clone: true })
export default zh
